import styled from 'styled-components';

export const ListContainer = styled.div.attrs({
  borderRadius: 10,
  overflow: 'hidden',
})`
  width: 100%;
  margin: 10px 0 16px;
`;
